import { render } from "./card-left.vue?vue&type=template&id=a97c6380"
import script from "./card-left.vue?vue&type=script&lang=ts"
export * from "./card-left.vue?vue&type=script&lang=ts"

import "./card-left.vue?vue&type=style&index=0&id=a97c6380&lang=css"
script.render = render

export default script